
import {
    axios
} from '@/utils/request'

const list = (parameter) => {
    return axios({
        url: '/pmsCategory/list',
        method: 'post',
        data: parameter
    })
}
const add = (parameter) => {
    return axios({
        url: '/pmsCategory',
        method: 'post',
        data: parameter
    })
}
const update = (parameter) => {
    return axios({
        url: '/pmsCategory',
        method: 'PUT',
        data: parameter
    })
}
const del = (parameter) => {
    return axios({
        url: '/pmsCategory',
        method: 'delete',
        params: parameter
    })
}
export {
    list,
    add,
    update,
    del
}
